import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { ROUTE_TYPES } from 'constants/survey';
import { connect } from 'react-redux';
import { resetFrom, nextStep, updateSurvey, checkLastStep } from 'store/actions';
import Analytics from '../../utils/analytics';

import StepperNav from 'components/StepperNav/StepperNav';
import SelectionCard from 'components/SelectionCard/SelectionCard';

import internationalImg from 'assets/images/routes/international.png';
import nationalImg from 'assets/images/routes/national.png';
import regionalImg from 'assets/images/routes/regional.png';
import lastMileImg from 'assets/images/routes/last-mile.png';

const mapStateToProps = (state) => ({
  isLastStep: state.isLastStep,
  survey: state.survey
});

const mapDispatchToProps = (dispatch) => ({
  resetFrom: (prop) => dispatch(resetFrom(prop)),
  nextStep: () => dispatch(nextStep()),
  updateSurvey: (survey) => dispatch(updateSurvey(survey)),
  checkLastStep: () => dispatch(checkLastStep())
});

class Step3 extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      selectedRoutes: []
    };
  }

  componentDidMount() {
    const { survey } = this.props;

    if (survey.routeType.length) {
      this.setState({selectedRoutes: survey.routeType.split(',')});
    }
  }

  handleRoutesSelection = (selectedRoute) => {
    const { survey, resetFrom, updateSurvey, checkLastStep } = this.props;
    let selectedRoutes = this.state.selectedRoutes;
    let index = selectedRoutes.indexOf(selectedRoute);

    if (index !== -1) {
      selectedRoutes.splice(index, 1);
    } else {
      selectedRoutes.push(selectedRoute);
    }

    this.setState({selectedRoutes: selectedRoutes.sort()});

    if (!survey.routeType.length) {
      // Update data from the last step
      const updatedSurvey = {
        ...survey,
        ...{routeType: selectedRoutes.join()},
      };

      updateSurvey(updatedSurvey);
    } else if (survey.routeType !== selectedRoutes.join()) {
      resetFrom({routeType: selectedRoutes.join()});
    }
    checkLastStep();
  }

  handleSelection = (selectedRoutes) => {
    const { survey, resetFrom, updateSurvey } = this.props;
    if (!survey.routeType.length || survey.routeType === selectedRoutes.join()) {
      // Update data from the last step
      const updatedSurvey = {
        ...survey,
        ...{routeType: selectedRoutes.join()},
      };

      updateSurvey(updatedSurvey);
    } else {
      resetFrom({routeType: selectedRoutes.join()});
    }

    const filteredType = Analytics.removeAccentMarkAndUppercase(selectedRoutes.join());

    Analytics.pushData({
      eventCategory: 'recomendador starressa',
      eventAction: 'clic boton',
      eventLabel: `step3_ruta habitual_${filteredType}`
    });
  }

  render() {
    const { t, isLastStep, survey } = this.props;

    const routeTypes = [
      {
        name: t(ROUTE_TYPES.INTERNATIONAL),
        imgSrc: internationalImg
      },
      {
        name: t(ROUTE_TYPES.NATIONAL),
        imgSrc: nationalImg
      },
      {
        name: t(ROUTE_TYPES.REGIONAL),
        imgSrc: regionalImg
      },
      {
        name: t(ROUTE_TYPES.LAST_MILE),
        imgSrc: lastMileImg
      }
    ]

    return (
      <section className="m-step m-step3">
        <div className="m-step__header">
          <h2 className="t-h2 m-step__title">{t('steps.step3.title')}</h2>
          <h3 className="t-h3">{t('steps.step3.subtitle')}</h3>
        </div>
        <div className="m-step m-step__content">
          <div className="m-step__cards-wrapper">
            {
              routeTypes.map((type, index) => {
                const cardActive = survey.routeType.length && survey.routeType.indexOf(routeTypes[index].name) !== -1;
                return (
                  <SelectionCard
                    extraClass={"m-step__card m-step__card--half"}
                    key={index}
                    onClick={() => this.handleRoutesSelection(routeTypes[index].name)}
                    label={routeTypes[index].name}
                    imgSrc={routeTypes[index].imgSrc}
                    checkBoxCard={true}
                    checkBoxChecked={cardActive} />
                );
              })
            }
          </div>
        </div>
        <StepperNav
          disableNextBtn={(this.state.selectedRoutes.length === 0)}
          onCLickNext={() => this.handleSelection(this.state.selectedRoutes)}
          showResultBtn={isLastStep} />
      </section>
    );
  }
}

const ConnectedStep3 = connect(mapStateToProps, mapDispatchToProps)(Step3);
export default withTranslation('translations')(ConnectedStep3);
